"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockType = exports.ShiftType = void 0;
var ShiftType;
(function (ShiftType) {
    ShiftType["RESERVATION"] = "reservation";
    ShiftType["TAKEAWAY"] = "takeAway";
    ShiftType["GUEST_ORDERING"] = "guestOrdering";
    ShiftType["HAPPY_HOURS"] = "happyHours";
    ShiftType["ENTRANCE_TICKET"] = "entranceTicket";
})(ShiftType = exports.ShiftType || (exports.ShiftType = {}));
var BlockType;
(function (BlockType) {
    BlockType["BLOCK"] = "block";
    BlockType["UNBLOCK"] = "unblock";
    BlockType["MAX_GUESTS"] = "max_guests";
    BlockType["CLOSE_TERRACE"] = "close_terrace";
    BlockType["OPEN_TERRACE"] = "open_terrace";
})(BlockType = exports.BlockType || (exports.BlockType = {}));
